import React from 'react'
import { Col } from 'antd'
import { useSelector } from 'react-redux'

import { ApplicationState } from 'src/store'
import { useStepsContext } from 'src/views/Requests/views/Form'
import StepsNavigation from 'src/views/Requests/views/Form/components/StepsNavigation'

import { WrapRow } from '../../../styles'
import BudgetCard from '../../../Assignment/components/Budget/budget-card'
import SearchCard from './components/SearchCard'
import SearchResultCard from './components/SearchResultCard'
import SummaryCard from './components/SummaryCard'

function Air() {
  const {
    air: { searches }
  } = useSelector((state: ApplicationState) => ({
    air: state.air
  }))
  const stepsContext = useStepsContext()
  const hasFinishedLoading =
    !!Object.keys(searches).length &&
    Object.values(searches).every(({ loading }) => !loading)

  return (
    <>
      <StepsNavigation />
      <WrapRow>
        <Col span={15}>
          <SearchCard request={stepsContext.request} />
          {hasFinishedLoading && <SearchResultCard />}
        </Col>
        <Col offset={1} span={8}>
          {stepsContext.budgetChartAllocations.active && <BudgetCard />}
          <SummaryCard
            bodyStyle={{ minHeight: 220 }}
            handleDelete={deleteItem => {
              stepsContext.setBudgetAllocations({
                standard_type: 'AIR',
                tickets: []
              })

              stepsContext.setRequest({
                ...stepsContext.request,
                full_request_air: []
              })
            }}
            request={stepsContext.request}
          />
        </Col>
      </WrapRow>
    </>
  )
}

export default Air
